import {
  LightbulbIcon as Lightbulb,
  ChartBarIcon as ChartBar,
} from "@phosphor-icons/react";

const TONE_BY_DIMENSION = {
  unjournaled:       { stripe: "#a2191f", riskLabel: "Critical risk" },
  archive_candidate: { stripe: "#0043ce", riskLabel: "Quick win"     },
  orphan:            { stripe: "#a56600", riskLabel: "Decommission"  },
  operational:       { stripe: "#525252", riskLabel: "Hygiene"       },
};

/** Right-rail card surfacing rule-based playbook recommendations
 *  derived from common IBM i file-name suffixes (MAST/HIST/TRN/LOG/…). */
export default function PatternRecommendations({ rows, loading }) {
  return (
    <div className="ml-card p-5" data-testid="pattern-recommendations">
      <div className="flex items-center gap-1.5 ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)] mb-3">
        <Lightbulb size={11} weight="bold" />
        Suggested playbooks
      </div>
      <h2 className="text-lg font-semibold mb-4">Patterns we&apos;ve seen before</h2>
      {loading ? (
        <div className="text-sm text-[var(--ml-text-secondary)]" data-testid="patterns-loading">
          Scanning suffixes…
        </div>
      ) : rows.length === 0 ? (
        <div
          className="text-sm text-[var(--ml-text-secondary)]"
          data-testid="patterns-empty"
        >
          No known suffix patterns matched in your engagements yet. Import a
          larger catalog to surface portfolio-wide playbooks.
        </div>
      ) : (
        <ul className="space-y-3" data-testid="patterns-list">
          {rows.map((p) => {
            const tone = TONE_BY_DIMENSION[p.risk_dimension] || TONE_BY_DIMENSION.operational;
            return (
              <li
                key={p.suffix}
                data-testid={`pattern-${p.suffix}`}
                className="border-l-2 pl-3 py-1"
                style={{ borderLeftColor: tone.stripe }}
              >
                <div className="flex items-baseline justify-between gap-2">
                  <div className="font-mono text-sm font-semibold">*{p.suffix}</div>
                  <div className="ml-mono text-[10px] uppercase tracking-widest" style={{ color: tone.stripe }}>
                    {tone.riskLabel}
                  </div>
                </div>
                <div className="text-xs text-[var(--ml-text-primary)] mt-0.5">{p.label}</div>
                <div className="text-xs text-[var(--ml-text-secondary)] mt-1 leading-relaxed">
                  {p.rationale}
                </div>
                <div className="mt-1.5 flex items-center gap-1.5 ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)]">
                  <ChartBar size={10} weight="bold" />
                  {p.risk_label} · {p.workspaces} engagement{p.workspaces === 1 ? "" : "s"}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
